<template lang="pug">
  .input-radio-group
    InputRadio.input-radio-group__item(
      v-for="option of options"
      :key="option.id"
      :id="option.id"
      :name="name"
      :checked="getChecked(option)"
      @input="(value) => $emit('update:modelValue', value)"
    ) {{ option.title }}
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import InputRadio from '@/components/InputRadio/InputRadio.vue';

  export default defineNuxtComponent({
    name: 'InputRadioGroup',

    components: {
      InputRadio,
    },

    props: {
      name: {
        type: String as PropType<string>,
        required: true,
      },
      options: {
        type: Array as PropType<Array<any>>,
        required: true,
      },
      modelValue: {
        required: true,
        validator: (value: any) => {
          return typeof value === 'string' || value === null;
        },
      },
    },

    computed: {},

    methods: {
      getChecked(option: any) {
        return option.id === this.modelValue;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .input-radio-group {
    display: flex;

    &__item {
      & + & {
        margin-left: 32px;
      }
    }
  }
</style>
